module.exports = __webpack_public_path__ + "img/rice_border.df12fb78.png";